import type { PropsWithChildren } from 'react';

import styled from 'styled-components'

import { type ITextButtonProps, TextButton } from '../TextButton'

export const InlineTextButtonStyled = styled(
  (props: PropsWithChildren<ITextButtonProps>) => (
    <TextButton {...props} />
  )
)`
  font-size: 1em;
  padding: 0;
`
